<template>
  <div class="m-2">
    <b-row>
      <!-- Per Page -->
      <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
        <label>{{ $t('Show') }}</label>
        <v-select :value="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
            :clearable="false" @input=" v => $emit('update:perPage', v)"
            class="per-page-selector d-inline-block mx-50"/>
        <label>{{ $t('entries') }}</label>
      </b-col>

      <!-- Search -->
      <b-col cols="12" md="6">
        <div class="d-flex align-items-center justify-content-end">
          <b-form-input @change="v => $emit('update:searchQuery', v)" class="d-inline-block mr-1"
                        :placeholder="$t('Search...')"/>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { BCol, BFormInput, BRow } from 'bootstrap-vue'

export default {
  name: 'TBPerPage',
  props: ['perPage', 'searchQuery', 'perPageOptions'],
  components: {vSelect, BFormInput, BRow, BCol},
  setup() {
  }
}
</script>

<style scoped>

</style>
